// src/icons/Icons.js
import React from 'react'

export const CaptainIcon = ({ className }) => (
    <svg
        id="fi_5731164"
        enableBackground="new 0 0 512 512"
        viewBox="0 0 512 512"
        data-slot="icon"
        className={`${className}`}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path d="m64.267 369.711c0 43.708 35.559 79.267 79.267 79.267h224.934c43.708 0 79.267-35.559 79.267-79.267v-30.727h-383.468z" />
            <path d="m507.607 166.306c-131.748-137.75-371.551-137.673-503.214 0-4.564 4.565-5.696 11.54-2.809 17.314l62.682 125.365h383.467l62.682-125.365c2.888-5.775 1.757-12.749-2.808-17.314zm-236.607 81.839v1.067c-.738 19.881-29.269 19.866-30 0v-1.067c-28.828 0-48.2-22.509-48.2-47.133 0-8.284 6.716-14.992 15-14.992s15 6.724 15 15.008c0 7.608 5.52 17.117 18.2 17.117v-42.3h-1.066c-19.881-.738-19.866-29.269 0-30h1.066v-1.067c.738-19.881 29.269-19.866 30 0v1.067h1.066c19.881.738 19.866 29.269 0 30h-1.066v42.3c12.68 0 18.2-9.51 18.2-17.117 0-8.284 6.716-15.008 15-15.008s15 6.708 15 14.992c0 24.624-19.372 47.133-48.2 47.133z" />
        </g>
    </svg>
)

export const BoatIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-slot="icon"
        viewBox="0 0 24 24"
        version="1.1"
        className={`${className}`}
        id="fi_7087902"
    >
        <g id="Icon">
            <path d="M2.308,20.613c-0,0 0.999,-0.449 1.903,-0.856c0.672,-0.302 1.449,-0.257 2.081,0.122l0.445,0.268c1.188,0.712 2.671,0.712 3.859,-0l0.246,-0.148c0.713,-0.428 1.603,-0.428 2.316,-0l0.246,0.148c1.188,0.712 2.671,0.712 3.859,-0l0.445,-0.268c0.632,-0.379 1.409,-0.424 2.081,-0.122c0.904,0.407 1.903,0.856 1.903,0.856c0.378,0.17 0.822,0.002 0.992,-0.376c0.17,-0.377 0.001,-0.822 -0.376,-0.991c-0,-0 -0.999,-0.45 -1.904,-0.857c-1.119,-0.504 -2.415,-0.428 -3.468,0.204c0,0 -0.445,0.267 -0.445,0.267c-0.713,0.428 -1.603,0.428 -2.315,0l-0.247,-0.148c-1.187,-0.712 -2.671,-0.712 -3.858,0l-0.247,0.148c-0.712,0.428 -1.602,0.428 -2.315,0l-0.445,-0.267c-1.053,-0.632 -2.349,-0.708 -3.468,-0.204c-0.905,0.407 -1.904,0.857 -1.904,0.857c-0.377,0.169 -0.546,0.614 -0.376,0.991c0.17,0.378 0.614,0.546 0.992,0.376Z"></path>
            <path d="M12.75,5.93l0,-2c-0,-0.414 -0.336,-0.75 -0.75,-0.75c-0.414,0 -0.75,0.336 -0.75,0.75l0,2c-0,0.414 0.336,0.75 0.75,0.75c0.414,0 0.75,-0.336 0.75,-0.75Z"></path>
            <path d="M5.111,11.145l5.923,-2.221c0.623,-0.234 1.309,-0.234 1.932,-0l5.923,2.221l-1.455,-4.729c-0.226,-0.735 -0.904,-1.236 -1.673,-1.236c-1.691,0 -5.831,0 -7.522,0c-0.769,0 -1.447,0.501 -1.673,1.236l-1.455,4.729Zm9.389,-3.965l-1,0c-0.414,0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l1,0c0.414,0 0.75,-0.336 0.75,-0.75c0,-0.414 -0.336,-0.75 -0.75,-0.75Zm-4,0l-1,0c-0.414,0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l1,0c0.414,0 0.75,-0.336 0.75,-0.75c0,-0.414 -0.336,-0.75 -0.75,-0.75Z"></path>
            <path d="M4.215,17.149c1.143,-0.226 2.343,-0.025 3.363,0.587l0.446,0.267c0.395,0.237 0.89,0.237 1.286,-0l0.246,-0.148c1.504,-0.903 3.384,-0.903 4.888,-0c-0,-0 0.26,0.156 0.246,0.148c0.396,0.237 0.891,0.237 1.286,-0c0,-0 0.446,-0.267 0.446,-0.267c1.02,-0.612 2.22,-0.813 3.363,-0.587l0.706,-2.65c0.232,-0.869 -0.234,-1.773 -1.076,-2.089l-6.801,-2.55c-0.396,-0.149 -0.832,-0.149 -1.228,-0l-6.801,2.55c-0.842,0.316 -1.308,1.22 -1.076,2.089l0.706,2.65Z"></path>
        </g>
    </svg>
)

export const MealMasterIcon = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 256 256"
        enableBackground="new 0 0 256 256"
        xmlSpace="preserve"
        className={`${className}`}
        data-slot="icon"
    >
        <g>
            <g>
                <path
                    fill="currentColor"
                    d="M10,139.8c0.3,60.8,50.4,102.3,111.8,102.3c61.4,0,116.1-41.6,116.4-102.3v-7.9H10.1L10,139.8z M187.6,117.9c9.4,0,12.6-9.5,9.5-16l26.4-78.4c1.3-3.8-0.8-7.9-4.6-9.2c-3.9-1.3-8,0.8-9.3,4.6l-26.3,77.9C173.6,100.7,175,117.9,187.6,117.9z M151.7,94.2c14.3,0,14.3-21.9,0-21.9C137.5,72.3,137.5,94.2,151.7,94.2z M151.7,127c14.3,0,14.3-21.9,0-21.9C137.5,105.1,137.5,127,151.7,127z M102.9,126.1c14.3,0,14.3-21.9,0-21.9C88.7,104.2,88.7,126.1,102.9,126.1z M125,103.3c14.3,0,14.3-21.9,0-21.9C110.8,81.4,110.8,103.3,125,103.3z M63.3,127c14.3,0,14.3-21.9,0-21.9C49.1,105.1,49.1,127,63.3,127z M241,28.9c-3.9-1.3-8,0.8-9.3,4.6l-27.1,80.3c-1.3,3.8,0.8,7.9,4.6,9.2c0.8,0.3,1.6,0.4,2.3,0.4c3.1,0,5.9-1.9,7-5l27.1-80.3C246.9,34.3,244.8,30.1,241,28.9z"
                />
            </g>
        </g>
    </svg>
)

export const UsersIcon = ({ className }) => (
    <svg
        id="fi_9424676"
        enableBackground="new 0 0 512 512"
        viewBox="0 0 512 512"
        className={`${className}`}
        data-slot="icon"
    >
        <g id="Icon">
            <g id="Users">
                <path d="m320.9 443.9h-266.1c-27.1 0-46.4-26.4-38.1-52.2l23.9-74.7c11-34.4 48-52.8 82.3-41.4 17.7 5.9 39.3 10.1 64.9 10.1s47.3-4.3 64.9-10.1c34.3-11.4 71.3 7 82.3 41.4l23.9 74.7c8.4 25.8-10.9 52.2-38 52.2z"></path>
                <circle cx="187.9" cy="159.9" r="91.7"></circle>
                <path d="m457.2 443.9h-91.5c1.3-1.5 2.5-3 3.7-4.6 11.4-15.7 14.6-35.2 8.7-53.7l-23.9-74.7c-.5-1.6-1-3.1-1.6-4.7 17.8-.4 33.3-3.1 46.5-6.9 33.9-9.9 69.5 8.9 80.2 42.5l16 49.8c8.2 25.9-11 52.3-38.1 52.3z"></path>
                <path d="m435.2 165c0 47.8-38.8 86.6-86.6 86.6-26.8 0-50.8-12.2-66.7-31.4 11.2-17.4 17.8-38.2 17.8-60.4 0-19.7-5.1-38.2-14.1-54.3 15.8-16.8 38.2-27.2 63-27.2 47.8.1 86.6 38.8 86.6 86.7z"></path>
            </g>
        </g>
    </svg>
)

export const RoutesIcon = ({ className }) => (
    <svg
        version="1.1"
        id="fi_64676"
        x="0px"
        y="0px"
        className={`${className}`}
        viewBox="0 0 575.732 575.732"
        data-slot="icon"
    >
        <g>
            <g id="Layer_1_9_">
                <g>
                    <path
                        d="M574.706,516.091l-51-207.825c-3.825-14.024-17.851-22.95-31.875-20.399c0,0-102,20.399-104.55,20.399
            c-19.125,35.7-39.525,70.125-58.65,102c-8.925,14.025-24.225,22.95-40.799,22.95c-16.575,0-31.875-8.925-40.8-22.95
            c-29.325-48.45-61.2-104.55-85.425-156.825l-93.075,36.975c-7.65,3.826-14.025,10.2-16.575,19.126l-51,205.274
            c-2.55,8.925,0,19.125,7.65,26.775c6.375,6.375,16.575,8.925,26.775,6.375l144.075-38.25c5.1-1.275,10.2-1.275,15.3,0
            l184.875,59.925c3.825,1.275,7.65,1.275,12.75,1.275l159.375-20.4c7.65-1.275,15.3-5.1,19.125-11.475
            S577.256,523.741,574.706,516.091z"
                    ></path>
                    <path
                        d="M287.832,396.241L287.832,396.241c3.825,0,6.375-2.55,8.924-5.1c29.325-47.175,118.575-200.175,118.575-258.825
            c0-70.125-57.375-127.5-127.5-127.5c-70.125,0-127.5,57.375-127.5,127.5c0,58.65,89.25,211.65,118.575,258.825
            C281.457,393.691,285.281,396.241,287.832,396.241z M225.356,131.041c0-33.15,26.775-61.2,61.2-61.2
            c33.15,0,61.2,26.775,61.2,61.2c0,33.15-26.775,61.2-61.2,61.2C252.131,192.241,225.356,165.466,225.356,131.041z"
                    ></path>
                </g>
            </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
    </svg>
)

export const RoutesOperationsIcon = ({ className }) => (
    <svg
        clipRule="evenodd"
        fillRule="evenodd"
        strokeLinejoin="round"
        className={`${className}`}
        data-slot="icon"
        strokeMiterlimit="2"
        viewBox="0 0 24 24"
        id="fi_7320176"
    >
        <g id="Icon">
            <path d="m12 1.25c-4.001 0-7.25 3.249-7.25 7.25 0 1.932 1.082 4.135 2.422 6.067 1.919 2.769 4.319 4.984 4.319 4.984.288.265.73.265 1.018 0 0 0 2.4-2.215 4.319-4.984 1.34-1.932 2.422-4.135 2.422-6.067 0-4.001-3.249-7.25-7.25-7.25zm0 4.75c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z"></path>
            <path d="m17.609 15.196c-1.972 2.827-4.412 5.08-4.422 5.09-.67.619-1.704.619-2.374 0-.01-.01-2.45-2.263-4.422-5.09-.457.179-.87.378-1.231.593-1.248.745-1.91 1.718-1.91 2.711s.662 1.966 1.91 2.711c1.544.921 4.031 1.539 6.84 1.539s5.296-.618 6.84-1.539c1.248-.745 1.91-1.718 1.91-2.711s-.662-1.966-1.91-2.711c-.361-.215-.774-.414-1.231-.593z"></path>
        </g>
    </svg>
)

export const BoatBookingImage = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={`${className}`} viewBox="0 0 54 54" fill="none">
        <path
            d="M14.0405 16.391C14.0405 16.391 11.3531 13.9906 7.36348 14.0114C6.40664 14.0114 6.4732 14.7644 7.36348 14.9683C8.25375 15.1721 9.75973 16.1123 10.2381 17.7556C12.156 17.7556 14.0405 16.391 14.0405 16.391Z"
            fill="#196CA2"
        />
        <path
            d="M25.6016 17.5891L23.3759 15.9458C23.3759 15.9458 22.3192 15.0681 20.651 15.3884C18.8787 15.7295 4.72174 17.6598 4.72174 17.6598C4.72174 17.6598 3.29897 17.7763 2.99943 19.3405C2.70406 20.8798 2.60838 21.2875 2.60838 21.2875L25.6016 17.5891Z"
            fill="#78A3AD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.524199 29.9989L2.48363 35.1616C3.07021 36.9047 4.69267 38.1736 6.62299 38.2318L6.62715 38.236L36.2683 38.1985C38.2776 38.0197 40.0831 37.1419 41.4435 35.8106L52.1393 24.936C52.3764 24.728 52.6177 24.4326 52.6177 24.0665C52.6177 23.5007 52.1601 23.0389 51.5901 23.0389C51.5152 23.0389 2.15498 27.8231 2.04266 27.8314C1.13158 27.8814 0.470115 28.5345 0.470115 29.404C0.470115 29.612 0.470117 29.8533 0.524199 29.9989Z"
            fill="#E6E7E8"
        />
        <path
            d="M48.2869 23.7878C48.4367 23.6588 48.5823 23.4966 48.6904 23.3135C50.5209 23.1388 51.6067 23.0306 51.615 23.0306C52.1808 23.0306 52.6426 23.4924 52.6426 24.0582C52.6426 24.4243 52.4013 24.7155 52.1642 24.9277L41.4726 35.8023C40.1122 37.1336 38.3067 38.0114 36.2973 38.1903L33.3603 38.1944C34.2856 37.7356 35.1334 37.1348 35.873 36.4139L48.2869 23.7878Z"
            fill="#D1D3D4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6015 17.5891L33.1106 23.1138L12.9422 25.7181L8.89433 25.144L8.55736 23.1679L8.33271 20.651L17.6307 19.041L25.6015 17.5891Z"
            fill="#40C0E7"
        />
        <path
            d="M1.02342 27.977L20.9006 25.9843C34.8871 24.6281 51.5485 23.0181 51.5901 23.0181C52.1559 23.0181 52.6177 23.4799 52.6177 24.0457C52.6177 24.4118 52.3764 24.703 52.1393 24.9152L51.5568 25.5059L0.653163 30.3067L0.528357 29.9739C0.470114 29.8241 0.216346 29.0504 1.02342 27.977Z"
            fill="#ED6C30"
        />
        <path
            d="M12.2101 24.2121C13.4456 24.3202 13.0463 25.2854 13.0463 25.2854L1.34789 27.145L2.79563 20.443L25.0608 17.1731L27.145 18.7165C27.145 18.7165 10.833 21.0296 10.2922 21.1128C9.75141 21.196 9.53508 21.7784 9.51012 22.0571C9.46852 22.4898 9.33539 23.9625 12.2101 24.2121Z"
            fill="#196CA2"
        />
        <path d="M15.5963 20.0894L20.6301 24.8569L23.4548 24.5407L17.7721 19.819L15.5963 20.0894Z" fill="#196CA2" />
        <path
            d="M25.3272 22.7061C25.5269 22.7061 25.7224 22.6146 25.8514 22.4399C26.0594 22.1528 25.997 21.7493 25.7058 21.5371L21.5124 18.5002C21.3731 18.4061 21.2027 18.3698 21.0371 18.3992C20.8716 18.4285 20.724 18.5211 20.6256 18.6574C20.5272 18.7936 20.4857 18.9629 20.5099 19.1292C20.5341 19.2956 20.622 19.446 20.7552 19.5486L24.9486 22.5855C25.0651 22.6645 25.1982 22.7061 25.3272 22.7061Z"
            fill="white"
        />
        <path d="M1.02338 27.9771L35.9937 24.9027L32.9775 23.0306L1.61412 25.9344L1.02338 27.9771Z" fill="#78A3AD" />
        <path
            d="M3.01612 30.0945L4.77171 34.7165C5.37493 36.5053 6.93499 37.9115 8.83618 38.236H6.6313L6.62714 38.2318C4.70099 38.1736 3.07853 36.9047 2.48779 35.1616L0.640675 30.2984L3.01612 30.0945Z"
            fill="#D1D3D4"
        />
        <path
            d="M1.82213 40.0498H48.0082C48.549 40.0498 48.9941 39.6047 48.9941 39.0638C48.9941 38.523 48.549 38.0779 48.0082 38.0779H1.82213C1.28131 38.0779 0.836174 38.523 0.836174 39.0638C0.836174 39.6047 1.27715 40.0498 1.82213 40.0498Z"
            fill="#40C0E7"
        />
    </svg>
)

export const TripsIcon = ({ className }) => (
    <svg className={`${className}`} viewBox="0 0 24 24" data-slot="icon" id="fi_7166917" fill="none">
        <g>
            <path d="m14.844 20h-8.344c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5h7c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5h-4.861c-.36725.71988-.82203 1.39164-1.354 2h6.215c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5h9.593c-.4907-.6172-.9097-1.2882-1.249-2zm-9.844-18c-1.654 0-3 1.346-3 3 0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5c-.19705-.00007-.39215-.03894-.57418-.11441-.18202-.07547-.3474-.18605-.48669-.32543s-.24976-.30483-.3251-.48691c-.07535-.18207-.1141-.3772-.11403-.57425s.03894-.39215.11441-.57418c.07547-.18202.18605-.3474.32543-.48669s.30483-.24976.48691-.3251c.18207-.07535.3772-.1141.57425-.11403.39796.00013.77956.15835 1.06087.43984.2813.28149.43926.6632.43913 1.06116s-.15835.77956-.43984 1.06087c-.28149.2813-.6632.43926-1.06116.43913z"></path>
            <path d="m19 14c-1.654 0-3 1.346-3 3 0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5c-.197-.0001-.3922-.0389-.5742-.1144s-.3474-.1861-.4867-.3254c-.1393-.1394-.2497-.3049-.3251-.4869-.0753-.1821-.1141-.3773-.114-.5743s.0389-.3922.1144-.5742.1861-.3474.3254-.4867c.1394-.1393.3049-.2497.4869-.3251.1821-.0753.3773-.1141.5743-.114.398.0001.7796.1583 1.0609.4398s.4392.6632.4391 1.0612-.1583.7796-.4398 1.0609-.6632.4392-1.0612.4391z"></path>
        </g>
    </svg>
)

export const ReturnTripIcon = ({ className }) => (
    <svg className={`${className}`} viewBox="0 0 35 35" data-slot="icon" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            {/* Circular background with specific color - 35px size */}
            <circle cx="17.5" cy="17.5" r="17.5" fill="rgb(233 239 241)" stroke="none" />
            
            {/* Left curved arrow pointing right - same size, repositioned for 35px circle */}
            <path 
                d="M6 14C6 12.2 7.2 10.5 9 10.5H22L19 7.5M22 10.5L19 13.5" 
                stroke="#4A90A4" 
                strokeWidth="2.2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                fill="none"
            />
            {/* Right curved arrow pointing left - same size, repositioned for 35px circle */}
            <path 
                d="M29 21C29 22.8 27.8 24.5 26 24.5H13L16 27.5M13 24.5L16 21.5" 
                stroke="#4A90A4" 
                strokeWidth="2.2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                fill="none"
            />
        </g>
    </svg>
)






export const MedicalIcon = ({ className }) => (
    <svg
        viewBox="0 0 448 480"
        className={`${className}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
    >
        {/* Shield shape - exact from your image */}
        <path
            d="M224 0 
               C165 24, 88 48, 0 72
               C0 96, 0 144, 0 192
               C0 288, 48 384, 112 432
               C160 464, 192 472, 224 480
               C256 472, 288 464, 336 432
               C400 384, 448 288, 448 192
               C448 144, 448 96, 448 72
               C360 48, 283 24, 224 0 Z"
      
               fill= "rgb(25 108 162 / 63%)"
        />
        {/* White circle - exact measurements */}
        <circle cx="224" cy="240" r="112" fill="#ffffff" />
        {/* Black cross - horizontal arm */}
        <rect x="162" y="219.5" width="124" height="41"     fill="#DC2626" />
        {/* Black cross - vertical arm */}
        <rect x="203.5" y="178" width="41" height="124"     fill="#DC2626" />
    </svg>
)


export const CheckInIcon = ({ className, variant = "default" }) => {
    const getColors = () => {
        switch (variant) {
            case "filled":
                return {
                    circle: "#4A90A4", // Your teal theme color
                    check: "white",
                    fillCircle: "#4A90A4"
                }
            case "outlined":
                return {
                    circle: "#4A90A4",
                    check: "#4A90A4",
                    fillCircle: "none"
                }
            default:
                return {
                    circle: "currentColor",
                    check: "currentColor",
                    fillCircle: "none"
                }
        }
    }

    const colors = getColors()

    return (
        <svg
            viewBox="0 0 24 24"
            data-slot="icon"
            className={`${className}`}
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle 
                cx="12" 
                cy="12" 
                r="10" 
                fill={colors.fillCircle}
                stroke={colors.circle}
                strokeWidth="2"
            />
            <path 
                d="m9 12 2 2 4-4" 
                fill="none"
                stroke={colors.check}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const PassportIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        <rect x="3" y="2" width="18" height="20" rx="2" ry="2" />
        <circle cx="12" cy="10" r="3" />
        <path d="M7 18v-1a5 5 0 0 1 10 0v1" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="16" y1="2" x2="16" y2="6" />
    </svg>
)
